Namespace 'CustomerVisualMode'

class CustomerVisualMode.WidgetDataTranslatorFactory
  constructor: (accountAttributes, customAttribute) ->
    @accountAttributes = accountAttributes
    @customAttribute = customAttribute

  create: (dimension) ->
    switch dimension
      when Common.WidgetDimensions.SUBTYPE
        new CustomerVisualMode.SubtypeWidgetDataTranslator()
      when Common.WidgetDimensions.ASSIGNED_OPERATOR
        new CustomerVisualMode.UserWidgetDataTranslator()
      when Common.WidgetDimensions.ASSIGNED_GROUP
        new CustomerVisualMode.TeamWidgetDataTranslator(@accountAttributes.assignedTeam)
      when Common.WidgetDimensions.HIERARCHICAL_ATTRIBUTE
        new CustomerVisualMode.HierarchicalAttributeWidgetDataTranslator(@customAttribute)
      when Common.WidgetDimensions.CLOSED_CONVERSATIONS_PER_AGENT
        new CustomerVisualMode.UserWidgetDataTranslator()
      else
        @_identityTranslator()

  _identityTranslator: ->
    {name: (dataItem) -> dataItem.name}
